module.exports = __webpack_public_path__ + "static/media/Software Dev.58470bfe.svg";